import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Rules from "./pages/Rules";
import Whitelist from "./pages/Whitelist";
import Admins from "./pages/Admins";
import RulesEditor from "./pages/EditRules";
import Gallery from "./pages/Gallery";
import { AuthProvider } from "./AuthContext";
import RequireAuth from "./RequireAuth";
import RequireAdmin from "./RequireAdmin";
import AccessDenied from "./pages/AccessDenied";
import Tickets from "./pages/Tickets";

function App() {
    return (
        <Router>
            <AuthProvider>
                <div className="min-h-screen bg-black text-white flex flex-col">
                    <Header />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/pravidla" element={<Rules />} />
                            <Route path="/whitelist" element={<Whitelist />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/access-denied" element={<AccessDenied />} />
                            <Route path="/admins" element={<Admins />} />
                            <Route
                                path="/_edit_rules"
                                element={
                                    <RequireAdmin>
                                        <RulesEditor />
                                    </RequireAdmin>
                                }
                            />
                            <Route
                                path="/tickets"
                                element={
                                    <RequireAuth>
                                        <Tickets />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/tickets/:ticketId"
                                element={
                                    <RequireAuth>
                                        <Tickets />
                                    </RequireAuth>
                                }
                            />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </AuthProvider>
        </Router>
    );
}

export default App;
